export default "__VITE_ASSET__f6c63e40__"